export default __webpack_public_path__ + "static/media/land_nft.75625b27.png";